import { environment } from '../../environments/environment';

export const BASE_URL = environment.apiUrl;
export const CURRENT_USER = environment.sessionName;
export const PROD = environment.production;